module.exports = __webpack_public_path__ + "img/icon-gen-viewfaq.6513899a.png";